/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './CustomLoginHeader.module.scss';
import 'react-toastify/dist/ReactToastify.css';

export type Props = {
  onCreateAccount: (event: any) => void;
};

const CustomLoginFooter: FC<Props> = ({ onCreateAccount }) => {
  const { t } = useTranslation('i18n');

  return (
    <div className={styles.root}>
      <div className={styles.haveAccount}>
        {t('login.No account? ')}
        <a href='#' onClick={onCreateAccount}>
          {t('login.Create account')}
        </a>
      </div>
    </div>
  );
};

export default CustomLoginFooter;
